import { SCREENS } from "@white-label-configuration/constants";

export const preloaderItemsCount = (screenSize: number): Array<number>[] => {
  const isLargeDesktopResolution = screenSize >= SCREENS.XL;
  const isDesktopResolution = screenSize >= SCREENS.LG;
  const isTabletResolution = screenSize >= SCREENS.MD && screenSize < SCREENS.LG;

  if (isLargeDesktopResolution) {
    return Array(3);
  }
  if (isTabletResolution || isDesktopResolution) {
    return Array(2);
  }
  return Array(1);
}
